import type { ReactNode } from 'react'
import Section from './Section'

interface PageHeroProps {
  image: string
  overlay?: number
  title: string
  align?: 'left' | 'center'
  as?: 'h1' | 'h2'
  children?: ReactNode
}

/**
 * The photo banner at the top of inner pages (Registry, Privacy, Terms...).
 * Leaves room for the transparent header above the title.
 */
export default function PageHero({ image, overlay = 0.2, title, align = 'center', as = 'h1', children }: PageHeroProps) {
  const Tag = as
  return (
    <Section image={image} overlay={overlay} tone="light" className="pt-36 md:pt-48">
      <div className={`mx-auto max-w-[1800px] ${align === 'center' ? 'text-center' : ''}`}>
        <Tag className="drop-shadow-[0_2px_12px_rgba(0,0,0,0.25)]">{title}</Tag>
        {children}
      </div>
    </Section>
  )
}
